// RegExp object for chainId (string version)
// '0x' + at least one case-insensitive hexadecimal character
export const chainIdRegEx = new RegExp('0x[0-9a-fA-F]+$');
